{
    "Accessibility menu": "Prieinamumo meniu",
    "Close": "Uždaryti",
    "Text and Reading": "Tekstas ir skaitymas",
    "Navigation and Interaction": "Navigacija ir sąveika",
    "Text Align": "Teksto lygiavimas",
    "Align Left": "Lygiuoti kairėje",
    "Align Center": "Lygiuoti centre",
    "Align Right": "Lygiuoti dešinėje",
    "Adjust Font Size": "Koreguoti šrifto dydį",
    "Highlight Title": "Paryškinti antraštę",
    "Highlight Links": "Paryškinti nuorodas",
    "Readable Font": "Įskaitomas šriftas",
    "Color and Contrast": "Spalva ir kontrastas",
    "Dark Contrast": "Tamsus kontrastas",
    "Light Contrast": "Šviesus kontrastas",
    "High Contrast": "Aukštas kontrastas",
    "High Saturation": "Aukštas prisotinimas",
    "Low Saturation": "Žemas prisotinimas",
    "Monochrome": "Vienspalvis",
    "Tools": "Įrankiai",
    "Reading Guide": "Skaitymo gidas",
    "Big Cursor": "Didelis žymeklis",
    "Increase Font Size": "Padidinti šrifto dydį",
    "Decrease Font Size": "Sumažinti šrifto dydį",
    "Letter Spacing": "Raidžių tarpai",
    "Line Height": "Eilučių aukštis",
    "Font Weight": "Šrifto storis",
    "Dyslexia Font": "Disleksijos šriftas",
    "Language": "Kalba",
    "Accessibility widget": "Prieinamumo valdiklis",
    "Accessibility Profiles": "Prieinamumo profiliai",
    "Cognitive Disability": "Kognityvinė negalia",
    "Seizure Safe": "Saugus nuo priepuolių",
    "Accessibility statement": "Prieinamumo pareiškimas",
    "ADHD": "ADHD",
    "Low Vision": "Silpnaregystė",
    "Pause Animations": "Sustabdyti animacijas",
    "Animation paused": "Animacija pristabdyta",
    "Reset all settings": "Atkurti nustatymus",
    "Shortcut:": "Spartusis klavišas:",
    "Epilepsy Safe Mode": "Epilepsijai saugus režimas",
    "Mute sounds": "Nutildyti garsus",
    "Page read": "Skaityti puslapį",
    "Page read controls": "Puslapio skaitymo valdikliai",
    "Pause": "Pristabdyti",
    "Resume": "Tęsti",
    "Stop": "Sustabdyti",
    "Settings": "Nustatymai",
    "Speed": "Greitis",
    "Voice": "Balsas",
    "Close accessibility menu": "Uždaryti prieinamumo meniu",
    "Back to accessibility menu": "Atgal į prieinamumo meniu",
    "Search languages": "Ieškoti kalbų",
    "Selected language": "Pasirinkta kalba",
    "View accessibility statement (opens in new window)": "Peržiūrėti prieinamumo pareiškimą (atsidaro naujame lange)",
    "Visit CookieYes website (opens in new window)": "Apsilankyti CookieYes svetainėje (atsidaro naujame lange)",
    "Reset all accessibility settings to default": "Atkurti visus prieinamumo nustatymus į numatytuosius"
}
